import { jwtDecode, JwtPayload } from 'jwt-decode';

export const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode<JwtPayload>(accessToken);
  const currentTime = Date.now() / 1000;
  return decoded.exp !== undefined && decoded.exp > currentTime;
};

export const handleTokenExpired = (exp: number) => {
  let expiredTimer: ReturnType<typeof setTimeout> | undefined = undefined;

  const currentTime = Date.now();

  // Test token expires after 10s
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    console.log('Token expired');
    localStorage.removeItem('accessToken');
  }, timeLeft);
};
